(function() {

  const sortFonts = () => {
    const availableFonts = CPB.getStore().getState().App.settings.fonts.available
    const fontMeta = [...CPB.getStore().getState().Global.fonts]
    const langMap = {};
    fontMeta.forEach(f => {
      const isHebrew = f.label.includes('(Hebrew)');
      langMap[f.name] = isHebrew ? 'he' : 'en';
    });
    
    const sortedFonts = availableFonts.slice().sort((a, b) => {
      const langA = langMap[a] || 'en';
      const langB = langMap[b] || 'en';
      return langA.localeCompare(langB);
    });

    CPB.getStore().getState().App.settings.fonts.available = sortedFonts 
  }
  
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
    const container = document.querySelector('.cpb-panels-container')
    const check = document.querySelector('.cpb-discount')
    check.style.display = 'block'
    container.appendChild(check)

    sortFonts()
  })
})()